const sceneTypes = {
    OUTDOOR: 1,
    INDOOR: 2,
    RSTS: 3
}

export default sceneTypes